import { ShoppingCart } from 'lucide-react';

const POSEmptySelectedProducts = () => {
  return (
    <div
      className="
      flex
      flex-col
      items-center
      justify-center

      rounded-2xl

      border
      border-dashed
      border-stroke

      bg-whiter

      px-6
      py-10

      text-center

      shadow-1

      dark:border-strokedark
      dark:bg-boxdark
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Icon */}
      {/* ===================================================== */}
      <div
        className="
        flex
        h-14
        w-14
        items-center
        justify-center

        rounded-2xl

        border
        border-primary/15

        bg-primary/10

        text-primary

        shadow-sm
      "
      >
        <ShoppingCart size={26} />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Title */}
      {/* ===================================================== */}
      <h4
        className="
        mt-4

        text-sm
        font-semibold

        text-black

        dark:text-white
      "
      >
        No hay productos
      </h4>

      {/* ===================================================== */}
      {/* 🔹 Description */}
      {/* ===================================================== */}
      <p
        className="
        mt-2

        max-w-[240px]

        text-xs
        leading-relaxed

        text-body

        dark:text-bodydark1
      "
      >
        Agrega productos desde el panel izquierdo para comenzar la venta.
      </p>
    </div>
  );
};

export default POSEmptySelectedProducts;
